/* eslint-disable no-underscore-dangle */

export default function trackGA() {
  if (window._paq) {
    window._paq.push(['setCustomUrl', window.location]);
    window._paq.push(['trackPageView']);
  }
}
